define.alias("shared/components/shared/run-task", "settings/components/shared/run-task");